import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AuthGuard } from './security/auth.guard';
import { LicenseListComponent } from './components/licenses/license-list/license-list.component';
import { LicenseDetailComponent } from './components/licenses/license-detail/license-detail.component';
import { OrganizationListComponent } from './components/organizations/organization-list/organization-list.component';
import { OrganizationDetailComponent } from './components/organizations/organization-detail/organization-detail.component';
import { DeviceListComponent } from './components/devices/device-list/device-list.component';
import { DeviceDetailComponent } from './components/devices/device-detail/device-detail.component';
import { AppSettingComponent } from './components/app-setting/app-setting.component';
import { ReportTemplateListComponent } from './components/reportTemplate/report-template-list/report-template-list.component';
import { ReportTemplateDetailComponent } from './components/reportTemplate/report-template-detail/report-template-detail.component';
import { ReportTemplateV2DetailComponent } from './components/reportTemplate/report-template-v2-detail/report-template-v2-detail.component';
import { CameraListComponent } from './components/cameras/camera-list/camera-list.component';
import { CameraDetailComponent } from './components/cameras/camera-detail/camera-detail.component';
import { InspectionProviderListComponent } from './components/inspection-providers/inspection-provider-list/inspection-provider-list.component';
import { InspectionProviderDetailComponent } from './components/inspection-providers/inspection-provider-detail/inspection-provider-detail.component';
import { ParkingComponent } from './components/parking/parking-list/parking.component';
import { ParkingDetailsComponent } from './components/parking/parking-details/parking-details.component';
import { TsUploadDetailComponent } from './components/ts-upload-detail/ts-upload-detail.component';
import { OrganizationConfigComponent } from './components/organizationConfig/organization-config.component';
import { NoAccessComponent } from './components/no-access/no-access.component';
import { GuardianDetailComponent } from './components/guardians/guardian-detail/guardian-detail.component';
import { LocalityDetailComponent } from './components/localities/locality-detail/locality-detail.component';
import { AccountListComponent } from './components/accounts/account-list/account-list.component';
import { AccountDetailComponent } from './components/accounts/account-detail/account-detail.component';
import { DefaultAppSettingComponent } from './components/default-app-setting/default-app-setting.component';
import { DefaultReportTemplateListComponent } from './components/defaultReportTemplate/default-report-template-list/default-report-template-list.component';
import { DefaultReportTemplateDetailComponent } from './components/defaultReportTemplate/default-report-template-detail/default-report-template-detail.component';
import { DefaultReportTemplateV2ListComponent } from './components/defaultReportTemplate/default-report-template-v2-list/default-report-template-v2-list.component';
import { DefaultReportTemplateV2DetailComponent } from './components/defaultReportTemplate/default-report-template-v2-detail/default-report-template-v2-detail.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: 'licenses',
    component: LicenseListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'licenses/:id',
    component: LicenseDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'organizations',
    component: OrganizationListComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'organizations/:id',
    component: OrganizationDetailComponent,
    canActivate: [AuthGuard],
  },
  { path: 'devices', component: DeviceListComponent, canActivate: [AuthGuard] },
  {
    path: 'devices/:id',
    component: DeviceDetailComponent,
    canActivate: [AuthGuard],
  },
    {
    path: 'app-settings',
    component: AppSettingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'report-template',
    component: ReportTemplateListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'report-template/:id',
    component: ReportTemplateDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'report-template-v2/:id',
    component: ReportTemplateV2DetailComponent,
    canActivate: [AuthGuard],
  },

   {
    path: 'cameras',
    component: CameraListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cameras/:id',
    component: CameraDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'inspections-config',
    component: InspectionProviderListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'inspections-config/:id',
    component: InspectionProviderDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'parking',
    component: ParkingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'parking/:id/:clone',
    component: ParkingDetailsComponent,
    canActivate: [AuthGuard],
  },
   {
    path: 'ts-upload-file',
    component: TsUploadDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'organization-config',
    component: OrganizationConfigComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'guardians/:id',
    component: GuardianDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'localities/:id',
    component: LocalityDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'accounts',
    component: AccountListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'accounts/new',
    component: AccountDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'accounts/edit/:accountId',
    component: AccountDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'default-app-settings',
    component: DefaultAppSettingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'default-report-templates',
    component: DefaultReportTemplateListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'default-report-templates/new',
    component: DefaultReportTemplateDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'default-report-templates/edit/:type',
    component: DefaultReportTemplateDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'default-report-templates-v2',
    component: DefaultReportTemplateV2ListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'default-report-templates-v2/new',
    component: DefaultReportTemplateV2DetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'default-report-templates-v2/edit/:type',
    component: DefaultReportTemplateV2DetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'no-access',
    component: NoAccessComponent,
  },
];
